/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { GetOrganizationUser } from './organization-user.get';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetOrganizationUsers = {
  id: 'organization-users.get',
  tag: 'Organization',
  summary: 'Get organization users',
  description: 'Retrieve all users of an organization',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/user`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(GetOrganizationUser.response['200'].content['application/json'].schema),
        },
      },
    },
  },
} as const satisfies Endpoint;
